import { Box, styled } from "@mui/material";

export const ContainerBox = styled(Box)({
  display: "flex",
  flexDirection: "column",
});
